import { render, staticRenderFns } from "./SEOSetting.vue?vue&type=template&id=8befe22e&scoped=true&"
import script from "./SEOSetting.vue?vue&type=script&lang=js&"
export * from "./SEOSetting.vue?vue&type=script&lang=js&"
import style0 from "./SEOSetting.vue?vue&type=style&index=0&id=8befe22e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8befe22e",
  null
  
)

export default component.exports